import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  address: {
    '& .mantine-TextInput-input': {
      borderRadius: '8px',
      border: '1px solid #D0D5DD'
    },

    '& .mantine-TextInput-label': {
      color: theme.colors.brandGray[0],
      fontSize: '12px',
      fontWeight: 400
    }
  }
}));
